import { useEffect, useState } from "react";
import { toast } from "sonner";
import { getClients, createClient, deleteClient } from "./opsApi";
import { useOpsAuth } from "./OpsAuthContext";
import { Plus, Trash2 } from "lucide-react";

export default function OpsClients() {
  const { user } = useOpsAuth();
  const isSuper = user?.role === "super_admin";
  const [rows, setRows] = useState([]);
  const [name, setName] = useState("");
  const [notes, setNotes] = useState("");

  const load = () => getClients().then(setRows).catch(() => {});
  useEffect(() => { load(); }, []);

  const add = async () => {
    if (!name.trim()) return;
    try { await createClient({ name, notes }); setName(""); setNotes(""); load(); toast.success("Cliente creado"); }
    catch (e) { toast.error(e?.response?.data?.detail || "Error"); }
  };
  const del = async (id) => { await deleteClient(id); load(); };

  return (
    <div data-testid="ops-clients">
      <h2 className="mb-5 font-serif text-2xl font-bold text-white">Clientes / Marcas</h2>
      {isSuper && (
        <div className="mb-6 flex flex-wrap items-end gap-3 rounded-2xl border border-white/10 bg-[#241010] p-4">
          <div className="flex-1 min-w-[160px]"><label className="mb-1 block text-xs text-white/50">Nombre</label><input data-testid="ops-client-name" value={name} onChange={(e) => setName(e.target.value)} className="w-full rounded-lg border border-white/10 bg-white/5 px-3 py-2 text-sm text-white outline-none focus:border-[#AC3333]" /></div>
          <div className="flex-[2] min-w-[200px]"><label className="mb-1 block text-xs text-white/50">Notas</label><input data-testid="ops-client-notes" value={notes} onChange={(e) => setNotes(e.target.value)} className="w-full rounded-lg border border-white/10 bg-white/5 px-3 py-2 text-sm text-white outline-none focus:border-[#AC3333]" /></div>
          <button data-testid="ops-client-add" onClick={add} className="flex items-center gap-1.5 rounded-lg bg-[#AC3333] px-4 py-2 text-sm font-semibold text-white hover:bg-[#FF0505]"><Plus className="h-4 w-4" /> Añadir</button>
        </div>
      )}
      <div className="grid gap-3 sm:grid-cols-2 lg:grid-cols-3">
        {rows.map((c) => (
          <div key={c.id} data-testid={`ops-client-${c.id}`} className="rounded-2xl border border-white/10 bg-[#241010] p-4">
            <div className="flex items-start justify-between">
              <div className="font-serif text-lg font-bold text-white">{c.name}</div>
              {isSuper && <button data-testid={`ops-client-del-${c.id}`} onClick={() => del(c.id)} className="rounded-md border border-red-500/30 bg-red-500/10 p-1.5 text-red-300"><Trash2 className="h-3.5 w-3.5" /></button>}
            </div>
            {c.notes && <p className="mt-2 text-sm text-white/60">{c.notes}</p>}
          </div>
        ))}
        {rows.length === 0 && <p className="text-sm text-white/40">Aún no hay clientes.</p>}
      </div>
    </div>
  );
}
